<template>
    <div class="operate">
        <el-dialog :title="type_str == 'edit' ? '编辑分类' : '添加分类'" :visible.sync="dialogVisible" width="576px" :before-close="close">
            <div class="content">
                <el-form ref="form" :model="form" label-width="90px">
                    <el-form-item label="分类名称：" prop="name">
                        <el-input v-model="form.name" placeholder="请输入类目名称" clearable></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="medium" @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" size="medium" @click="onSubmit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
export default {
    data() {
        return {
            dialogVisible: false,
            form: {
                name: "",
            },
            id: 0,
            rowData: "",
            type_str: "create",
        };
    },
    mounted() {},
    created() {},
    computed: {
        ...mapGetters(["getToken"]),
    },
    methods: {
        ...mapActions({
            createCategoryApi: "brand/createCategory",
            editCategoryApi: "brand/editCategory",
        }),
        bindData(row, type_str = "create") {
            console.log(row);
            if (row == 0) {
                this.id = 0;
            } else {
                this.rowData = row;
                this.type_str = type_str;
                this.id = row.id;
                if (type_str == "edit") {
                    this.form.name = row.name;
                }
            }
        },
        onSubmit() {
            let opt = {
                token: this.getToken,
                // parent_id: Number(this.id), //上级分类id，  当添加一级类目时传0
                name: this.form.name, //类目名称
            };
            let url;
            if (this.type_str == "create") {
                url = this.createCategoryApi;
                opt.parent_id = Number(this.id);
            } else if (this.type_str == "edit") {
                url = this.editCategoryApi;
                opt.id = Number(this.id);
            }
            url(opt).then(({ data }) => {
                if (data.code == 1) {
                    this.$message.success(`${this.type_str == "create" ? "添加" : "编辑"}成功！`);
                    this.close();
                    this.$emit("init");
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        close() {
            this.form.name = "";
            this.dialogVisible = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.operate {
    .content {
        max-height: 500px;
        overflow-y: auto;
        &::-webkit-scrollbar-track-piece {
            background: #d3dce6;
        }

        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-thumb {
            background: #99a9bf;
            border-radius: 20px;
        }
    }
}
</style>